import { forwardRef, useEffect, useState } from 'react';
import mapIcon from '../assets/карта.png';
import { apiClient } from '../api/client';

interface AddressBlockProps {
  className?: string;
  userId?: string | null;
  addressText?: string;
}

const AddressBlock = forwardRef<HTMLDivElement, AddressBlockProps>(
  ({ className = '', userId, addressText }, ref) => {
    const [loadedPickupPoint, setPickupPoint] = useState<string>(addressText || '');

    useEffect(() => {
      if (addressText) return;

      if (!userId) return;

      let isMounted = true;

      const loadUserAddress = async () => {
        try {
          const response = await apiClient.getUser(userId);
          if (!isMounted) return;
          if (response.success && response.data) {
            setPickupPoint(response.data.pickup_point || '');
          }
        } catch (err) {
          console.error('Failed to load user pickup point:', err);
        }
      };

      loadUserAddress();

      return () => {
        isMounted = false;
      };
    }, [addressText, userId]);

    return (
      <div
        ref={ref}
        className={`flex min-h-[72px] items-center rounded-[18px] bg-white px-4 transition-all duration-300 hover:shadow-lg sm:min-h-[80px] sm:rounded-[20px] sm:px-5 ${className}`}
      >
        <div className="h-[24px] w-[24px] flex-shrink-0 sm:h-[30px] sm:w-[30px]">
          <img src={mapIcon} alt="Карта" className="w-full h-full object-contain" />
        </div>

        <div className="ml-3 flex flex-1 flex-col justify-center sm:ml-4">
          <h3 className="text-[18px] font-extrabold leading-[1.2] text-black sm:text-[22px] sm:tracking-[1px] sm:leading-[28px]">
            Ваш пункт выдачи
          </h3>
          <p className="text-[13px] font-semibold leading-[18px] text-[#5d76cb] sm:text-[14px] sm:leading-[20px]">
            {addressText || (userId ? loadedPickupPoint : '') || 'ПВЗ не выбран'}
          </p>
        </div>
      </div>
    );
  }
);

AddressBlock.displayName = 'AddressBlock';

export default AddressBlock;

